import { Suspense, lazy } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Spinner } from "@/components/ui/spinner";
import { useCustomJoinPageState } from "./useCustomJoinPageState";

// CodeMirror and friends only load when the tab is actually opened.
const CustomJoinPageEditor = lazy(() => import("./CustomJoinPageEditor"));

export function CustomJoinPageTab() {
  const { data, isLoading, isError, refetch } = useCustomJoinPageState();

  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner />
      </div>
    );
  }

  if (isError || !data) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Custom join page</CardTitle>
          <CardDescription>Couldn't load your page. Refresh to try again.</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  if (!data.enabled) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Custom join page</CardTitle>
          <CardDescription>
            Design your public join page with your own HTML and CSS. This is switched on per brand
            by the Reveshare team — get in touch if you'd like it enabled.
          </CardDescription>
        </CardHeader>
        {data.adminNote && (
          <CardContent>
            <p className="text-sm text-muted-foreground">
              <span className="font-medium text-foreground">Note from Reveshare:</span> {data.adminNote}
            </p>
          </CardContent>
        )}
      </Card>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="flex justify-center py-16">
          <Spinner />
        </div>
      }
    >
      <CustomJoinPageEditor initial={data} onStateChange={() => refetch()} />
    </Suspense>
  );
}
